<template>
    <ModalContent stitch>
        <template v-slot:title>{{ $translate("title") }}</template>

        <template v-slot:content>
            <p class="font-weight-bold mb-2 text-h3">
                {{ $translate("subtitle") }}
            </p>
            <p class="mb-2">
                {{ $translate("intro") }}
            </p>
            <p class="mb-4">
                {{ $translate("instruction") }}
            </p>

            <v-btn
                class="my-2"
                :loading="isSending"
                :disabled="isSending"
                @click="resendConfirmationEmail"
                color="primary"
            >
                {{ $translate("resend") }}
            </v-btn>

            <p v-if="successMessage" class="text-success mt-2">
                <v-icon class="mr-2" color="success">mdi-check</v-icon>
                {{ successMessage }}
            </p>
            <p v-if="errorMessage" class="text-error mt-2">
                <v-icon class="mr-2" color="error">mdi-alert</v-icon>
                {{ errorMessage }}
            </p>

            <p class="mt-4 text-muted">
                {{ $translate("contactHelp") }}
                <a href="mailto:contact@safetee.io">contact@safetee.io</a>.
            </p>
        </template>

        <template v-slot:bottom>
            <v-btn class="my-2 my-sm-4 w-100 w-sm-auto" @click="hideModal">
                {{ $translate("close") }}
            </v-btn>
        </template>
    </ModalContent>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";

export default {
    props: {
        params: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            isSending: false,
            successMessage: null,
            errorMessage: null,
        };
    },
    methods: {
        ...mapActions("mcl", ["hideModal"]),

        async resendConfirmationEmail() {
            this.isSending = true;
            this.successMessage = null;
            this.errorMessage = null;

            try {
                const response = await axios.post("/api/account/sendconfirmationemail/");
                if (response.status === 200) {
                    this.successMessage = this.$translate("success");
                } else {
                    this.errorMessage = this.$translate("error");
                }
            } catch (err) {
                this.errorMessage = this.$translate("error");
            } finally {
                this.isSending = false;
            }
        },
    },
    i18n: {
        messages: {
            en: {
                title: "Email verification required",
                subtitle: "Please confirm your email",
                intro:
                    "Your email address must be verified in order to proceed with the requested operation. This verification helps ensure the security of your account and communications.",
                instruction:
                    "Please check your inbox and click the confirmation link we've sent to your email address. This only takes a moment, and helps us keep your account secure.",
                resend: "Resend confirmation email",
                success: "A new confirmation email has been sent successfully.",
                error:
                    "An error occurred while sending the confirmation email. Please try again.",
                contactHelp:
                    "If you haven't received the email or need assistance, contact us at",
                close: "Close",
            },
            fr: {
                title: "Vérification de l'email requise",
                subtitle: "Merci de confirmer votre adresse email",

                intro:
                    "Votre adresse email doit être vérifiée pour effectuer l'opération demandée. Cette vérification permet d'assurer la sécurité de votre compte et de vos échanges.",
                instruction:
                    "Veuillez consulter votre boîte de réception et cliquer sur le lien de confirmation que nous vous avons envoyé. Cela ne prend que quelques instants et garantit la protection de votre compte.",
                resend: "Renvoyer l'email de confirmation",
                success: "Un nouvel email de confirmation a été envoyé avec succès.",
                error:
                    "Une erreur est survenue lors de l'envoi de l'email. Veuillez réessayer.",
                contactHelp:
                    "Si vous ne recevez pas l'email ou si vous avez besoin d'aide, contactez-nous à l'adresse",
                close: "Fermer",
            },
        },
    },
};
</script>
